import React from 'react';
import { Navigate } from 'react-router-dom';
import { isGuest } from '../utils/guest';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const isAuthenticated = !!user;
  const roles = user?.roles || [user?.role];

  const hasAccess = allowedRoles.some((role) => roles.includes(role));

  // ✅ Allow guest users to access student routes
  if (!isAuthenticated && isGuest() && allowedRoles.includes('student')) {
    return children;
  }

  // 🚫 Redirect unauthenticated users (not guest either)
  if (!isAuthenticated) return <Navigate to="/login" />;

  // 🚫 Authenticated but no access
  if (!hasAccess) return <Navigate to="/" />;

  // ✅ Authenticated and allowed
  return children;
};

export default ProtectedRoute;
